module.exports = __webpack_public_path__ + "static/media/cat-lady3.9a6f5fc2.png";